import { isNative } from "@origin-digital/platform-helpers";
import { eventDispatcher, TOPICS } from "@origin-digital/event-dispatcher";
import { reportException } from "@origin-digital/reporting-client";
import { getResetPasswordLink } from "../../services/dapi";
import { showErrorNotification } from "../../utils/notifications";
import { errorTracking } from "../../utils/tracking";
import content from "../../components/Password/content.json";

const getResetPwLinkParams = () => {
  // Pass returnTo to tell the page to go back to this location
  const returnToUrl = encodeURIComponent(window.location.href);
  // Need to let reset pw app know if native to toggle its custom header
  return `?returnTo=${returnToUrl}${isNative() ? "&scope=native" : ""}`;
};

export const onPasswordEditClick = async () => {
  try {
    const resetPwLink = `${await getResetPasswordLink()}${getResetPwLinkParams()}`;
    eventDispatcher.dispatch({
      topic: TOPICS.NAV_TO_URL,
      payload: { url: resetPwLink, odinReturnToUri: true },
    });
  } catch (error: any) {
    showErrorNotification(content.error);
    errorTracking(error as Error);
    reportException("UpdatePassword", error as Error);
  }
};
